import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';
import { ChartConfiguration } from 'chart.js';


@Component({

selector:'app-merchant-revenue',

templateUrl:'./merchant-revenue.component.html',

styleUrls:['./merchant-revenue.component.scss']

})


export class MerchantRevenueComponent implements OnInit {


merchantId:any;


todayRevenue:any={};

monthlyRevenue:any={};

yearlyRevenue:any={};

totalRevenue:any={};
selectedChart:string = 'service';


// SERVICE REVENUE BAR CHART

public serviceChartData: ChartConfiguration<'bar'>['data'] = {

labels: [],

datasets: [
{
data: [],
label: 'Service Revenue'
}
]

};



public serviceChartOptions: ChartConfiguration<'bar'>['options'] = {

responsive:true

};




// MONTHLY REVENUE LINE CHART

public monthlyChartData: ChartConfiguration<'line'>['data'] = {

labels: [],

datasets: [
{
data: [],
label: 'Monthly Revenue',
fill:false,
tension:0.3
}
]

};



public monthlyChartOptions: ChartConfiguration<'line'>['options'] = {

responsive:true

};




// YEARLY REVENUE BAR CHART

public yearlyChartData: ChartConfiguration<'bar'>['data'] = {

labels: [],

datasets:[
{
data:[],
label:'Yearly Revenue'
}
]

};



public yearlyChartOptions: ChartConfiguration<'bar'>['options'] = {

responsive:true

};





constructor(
private apiService:ApiServiceService
){}





ngOnInit(){


this.merchantId =
localStorage.getItem('merchantId');


console.log(
"MERCHANT ID",
this.merchantId
);



this.loadRevenue();

}



changeChart(type:string){
  this.selectedChart = type;
}

loadRevenue(){


const date = new Date();




// TODAY REVENUE

this.apiService
.getTodayRevenue(

this.merchantId

)
.subscribe({

next:(res)=>{


console.log(
"TODAY REVENUE",
res
);



this.todayRevenue=res;


}

});







// MONTH REVENUE

this.apiService
.getMonthlyRevenue(

this.merchantId,

date.getFullYear(),

date.getMonth()+1

)
.subscribe({

next:(res)=>{


console.log(
"MONTH REVENUE",
res
);



this.monthlyRevenue=res;


}

});







// YEAR REVENUE

this.apiService
.getYearlyRevenue(

this.merchantId,

date.getFullYear()

)
.subscribe({

next:(res)=>{


console.log(
"YEAR REVENUE",
res
);



this.yearlyRevenue=res;


}

});








// TOTAL REVENUE

this.apiService
.getTotalRevenue(

this.merchantId

)
.subscribe({

next:(res)=>{


console.log(
"TOTAL REVENUE",
res
);



this.totalRevenue=res;




// SERVICE REVENUE CHART

const serviceRevenue =
res.serviceRevenue || {};



this.serviceChartData = {


labels:Object.keys(serviceRevenue),



datasets:[
{

data:Object.values(serviceRevenue) as number[],

label:'Service Revenue'

}

]


};



}

});








// MONTHLY CHART

this.apiService
.getMonthlyChartRevenue(

this.merchantId,

date.getFullYear()

)
.subscribe({

next:(res)=>{


console.log(
"MONTHLY CHART",
res
);



this.monthlyChartData = {


labels:res.labels,

datasets:[

{

data:res.data,

label:'Monthly Revenue',

fill:false,

tension:0.3

}

]


};



}

});










// YEARLY CHART

this.apiService
.getYearlyChartRevenue(

this.merchantId

)
.subscribe({

next:(res)=>{


console.log(
"YEARLY CHART",
res
);



this.yearlyChartData = {


labels:res.labels,


datasets:[

{

data:res.data,

label:'Yearly Revenue'

}

]


};



}

});



}



}